import request from '@/utils/request'

export function getListHotelLink(query) {
  return request({
    url: '/config-service/v1/hotel-link/list',
    method: 'get',
    params: query
  })
}

export function updateHotelLinkDetail(data) {
  return request({
    url: `/config-service/v1/hotel-link/${data.id}`,
    method: 'put',
    data: data
  })
}

export function getInfoButton() {
  return request({
    url: `/config-service/v1/hotel-link/getInfoButton`,
    method: 'get'
  })
}

export function changeStatus(data) {
  return request({
    url: `/config-service/v1/hotel-link/changeStatus`,
    method: 'post',
    data: data
  })
}
